import { expiryOptions } from './expiry';
import { normalizeTransfer } from './normalize-transfer';

export function getCreateTransferRequestParams(transfer) {
  let normalizedTransfer;

  if (transfer.files) {
    normalizedTransfer = normalizeTransfer(transfer);
  }

  let params = {
    recipients: normalizedTransfer.recipients,
    message: normalizedTransfer.message,
    from: normalizedTransfer.sender,
  };

  // Throw away email params if not an e-mail transfer.
  if (normalizedTransfer.type !== 'email') {
    params = {
      message: normalizedTransfer.message,
    };
  }

  // Only do plus features if we are there
  if (normalizedTransfer.userType === 'plus') {
    if (normalizedTransfer.password) {
      params['password'] = normalizedTransfer.password;
    }

    if (normalizedTransfer.expiry && expiryOptions[normalizedTransfer.expiry]) {
      params['expire_in'] = expiryOptions[normalizedTransfer.expiry];
    }
  }

  // Are we using a channel?
  if (normalizedTransfer.channel) {
    params['channel'] = normalizedTransfer.channel;
  }

  // Do we have a language?
  if (normalizedTransfer.language) {
    params['ui_language'] = normalizedTransfer.language;
  }

  if (normalizedTransfer.domainUserId) {
    params['domain_user_id'] = normalizedTransfer.domainUserId;
  }

  // Is this a forward? (Forwards don't need filenames)
  if (normalizedTransfer.parent_id) {
    params['parent_id'] = normalizedTransfer.parent_id;
  } else {
    params['files'] = normalizedTransfer.files.map((file) => ({
      name: file.name,
      size: file.size,
      item_type: file.apiType,
    }));
  }

  // Do we have an account id? (Account entity was added in v4 API)
  if (normalizedTransfer.accountId) {
    params['account_id'] = normalizedTransfer.accountId;
  }

  return params;
}
